import * as React from "react";
import { Layout, LayoutProps } from "react-admin";
import { GybAppBar } from "../views/components/gyb-appbar";
import NestedMenu from "../views/components/nested-menu";

/**
 * 全局 Layout：自定义 AppBar/菜单（铃铛通知已挂在 AppBar 工具栏内）。
 */
export const GybLayout: React.FC<LayoutProps> = (props) => (
  <Layout {...props} appBar={GybAppBar} menu={NestedMenu} />
);
